export const VERSION = '1791243969652';